
export const DropdownIndicator = (props) => {
    const { isDisabled } = props.selectProps;
    return (
        <div style={{ padding: '0 0.521vw', display: 'flex', alignItems: 'center' }}> {/* 0 10px */}
            <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '0.625vw', height: '0.625vw' }} viewBox="0 0 12 12"> {/* 12px */}
                <path fill={isDisabled ? '#cbd5e1' : '#334155'} d="M6 9L1 4h10z" />
            </svg>
        </div>
    );
};

export const ClearIndicator = (props) => {
    const { innerProps } = props;
    return (
        <div {...innerProps} style={{ padding: '0 0.208vw', display: 'flex', alignItems: 'center', cursor: 'pointer', color: '#94a3b8' }}> {/* 0 4px */}
            <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '0.625vw', height: '0.625vw' }} viewBox="0 0 14 14" fill="currentColor"> {/* 12px */}
                <path d="M7 5.586L11.293 1.293a1 1 0 1 1 1.414 1.414L8.414 7l4.293 4.293a1 1 0 0 1-1.414 1.414L7 8.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L5.586 7 1.293 2.707A1 1 0 0 1 2.707 1.293L7 5.586z" />
            </svg>
        </div>
    );
};